import styled from "styled-components";
import { VenueInfoStyles } from "../../types/styles/VenueInfoStyles";
import Icon from "../Icon/Icon";
import { MapPinSolid } from "../../assets/icons";
import { useTranslation } from "react-i18next";

export type VenueInfoProps = {
  providerName: string;
  providerLocation: string;
  providerLocationUrl: string;
  styles: VenueInfoStyles;
};

const Grid = styled.div<{ styles: VenueInfoStyles }>`
  display: grid;
  grid-template-columns: 20px auto;
  grid-template-rows: auto auto;
  color: ${({ styles }) => styles.OverallGeneralTextColour};
  align-items: center;
  column-gap: 4px;

  > svg {
    justify-self: center;
  }
`;
const StyledIcon = styled(Icon)`
  grid-row: 1;
  grid-column: 1;
`;

const LocationName = styled.div`
  grid-row: 1;
  grid-column: 2;
  font-weight: 600;
  font-size: 13px;
`;

const LocationLink = styled.a<{ styles: VenueInfoStyles }>`
  grid-row: 2;
  grid-column: 2;
  color: ${({ styles }) => styles.OverallGeneralTextColour};
  text-decoration: underline;
  font-size: 13px;
  font-weight: 400;
`;

export const VenueInfo: React.FC<VenueInfoProps> = ({
  providerName,
  providerLocation,
  providerLocationUrl,
  styles,
}) => {
  const { t } = useTranslation();

  return (
    <Grid styles={styles}>
      <StyledIcon icon={MapPinSolid} />
      <LocationName>{providerName}</LocationName>
      <LocationLink
        aria-label={t("VenueMapLinkAriaLabel", { providername: providerName })}
        href={providerLocationUrl}
        target="_blank"
        styles={styles}
      >
        {providerLocation}
      </LocationLink>
    </Grid>
  );
};

export default VenueInfo;
